webpackJsonp([77],{

/***/ 1108:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"page-not-found"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row cRow"},[_c('div',{staticClass:"col-sm-7"},[_c('img',{staticClass:"img-responsive",attrs:{"src":_vm.cdn + '/images/404.png',"alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-5"},[_c('div',{staticClass:"pnf-content"},[_c('div',{staticClass:"big-text"},[_vm._v("401")]),_vm._v(" "),_c('h1',[_vm._v("Oops!")]),_vm._v(" "),_c('p',[_vm._v("\n              Seems like the page you are looking for is being made on a faraway island.\n            ")]),_vm._v(" "),_c('router-link',{attrs:{"to":"/"}},[_c('div',{staticClass:"btn btn-primary"},[_vm._v("Back to Home")])])],1)])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 460:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_401_vue__ = __webpack_require__(818);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6636db2f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_401_vue__ = __webpack_require__(1108);
var normalizeComponent = __webpack_require__(56)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_401_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6636db2f_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_401_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 818:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    cdn: function cdn() {
      return "https://maverick-global-assets-cp52hf.s3.ap-southeast-1.amazonaws.com";
    }
  }
});

/***/ })

});


// WEBPACK FOOTER //
// static/js/77.bb6b9f65608d9b6e7251.js